import { GetOnboardingStatus1PlatformEnum } from '@DigitaleDoerfer/digitale-doerfer-api';
import pkg from '@package';
import { nativeApplicationVersion } from 'expo-application';
import { Platform } from 'react-native';

import { APP_VARIANT_IDENTIFIER } from '@/constants/app';

const appPackageVersion = pkg.version;

export const APP_VERSION = nativeApplicationVersion ?? appPackageVersion;

/**
 * Note: request with os WEB needs to be configured in the BE
 */
export const ONBOARDING_PARAMS = {
  appVariantIdentifier: APP_VARIANT_IDENTIFIER,
  appVariantVersionIdentifier: APP_VERSION,
  platform: Platform.select({
    default: GetOnboardingStatus1PlatformEnum.Web,
    ios: GetOnboardingStatus1PlatformEnum.Ios,
    android: GetOnboardingStatus1PlatformEnum.Android,
    web: GetOnboardingStatus1PlatformEnum.Web
  })
};
